var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedveh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 7C16.0785 7 16.75 7.67157 16.75 8.5V9.25H17.8895C18.3452 9.25 18.7762 9.45713 19.0608 9.81296L20.1713 11.201C20.3841 11.467 20.5 11.7974 20.5 12.1381V15.25C20.5 16.0784 19.8285 16.75 19 16.75C19 17.9927 17.9927 19 16.75 19C15.5073 19 14.5 17.9927 14.5 16.75H11.5C11.5 17.9927 10.4926 19 9.25 19C8.00736 19 7 17.9927 7 16.75C6.17157 16.75 5.5 16.0784 5.5 15.25V8.5C5.5 7.67157 6.17157 7 7 7H15.25ZM9.25 16C8.83579 16 8.5 16.3358 8.5 16.75C8.5 17.1642 8.83579 17.5 9.25 17.5C9.66421 17.5 10 17.1642 10 16.75C10 16.3358 9.66421 16 9.25 16ZM16.75 16C16.3358 16 16 16.3358 16 16.75C16 17.1642 16.3358 17.5 16.75 17.5C17.1642 17.5 17.5 17.1642 17.5 16.75C17.5 16.3358 17.1642 16 16.75 16ZM15.25 8.5H7V15.25H7.57292C7.98491 14.7897 8.58363 14.5 9.25 14.5C9.86512 14.5 10.4226 14.7469 10.8287 15.1469L10.9271 15.25H15.0729L15.159 15.159L15.25 15.0729V8.5ZM17.8895 10.75H16.75V14.5C17.3651 14.5 17.9226 14.7469 18.3287 15.1469L18.4271 15.25H19V12.1381L17.8895 10.75Z",
    fill: "#D35258"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedveh);
export default __webpack_public_path__ + "static/media/redveh.185e6d0325d485493caab7e4049cf196.svg";
export { ForwardRef as ReactComponent };